import React from "react";
import i18next from "i18next";

import {authRoles} from "../../auth/index.js";
import en from "./i18n/en.js";

i18next.addResourceBundle("en", "users", en);

const HomeConfig = {
  settings: {layout: {config: {}}},
  auth: authRoles.user,
  routes: [
    {
      path: "/users",
      exact: true,
      component: React.lazy(() => import("./users.js")),
    },
    {
      path: "/users/new",
      exact: true,
      component: React.lazy(() => import("./user_editor.js")),
    },
    {
      path: "/users/:userId",
      exact: true,
      component: React.lazy(() => import("./user_editor.js")),
    },
  ],
};

export default HomeConfig;
